import { FormFieldTypes } from "../../../../../data/formFieldType";

export const ResetPasswordData = {
    name: "ResetPasswordData",
    initialState: {
        password: "",
        confirmPassword: ""
    },
    formFields: [
        {
            id: "password",
            lable: "Password",
            Field_Name: "Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "password",
            fieldSetting: {
                placeholder: "",
            },
            validation: [{ type: "require" }, { type: "password" }],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "confirmPassword",
            lable: "Confirm Password",
            Field_Name: "Confirm Password",
            fieldType: FormFieldTypes.PASSWORD,
            dataField: "confirmPassword",
            fieldSetting: {
                placeholder: "",
            },
            validation: [{ type: "require" }, { type: "password" }],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
    ],
};


export const UpdateOtherRepresentativeData = {
    name: "UpdateOtherRepresentativeData",
    initialState: {
        nameofRepresentative: "",
        emailAddress: "",
        contactNumber: ""
    },
    formFields: [{
        id: "nameofRepresentative",
        lable: "Name of Representative",
        Field_Name: "Name of Representative",
        fieldType: FormFieldTypes.INPUT,
        dataField: "nameofRepresentative",
        fieldSetting: {
            placeholder: "",
        },
        validation: [{ type: "require" }],
        style: {
            containerCss: "col-md-12 mb-3",
        },
    },
    {
        id: "emailAddress",
        lable: "Email Address",
        Field_Name: "Email Address",
        fieldType: FormFieldTypes.INPUT,
        dataField: "emailAddress",
        fieldSetting: {
            placeholder: "",
        },
        validation: [{ type: "require" }],
        style: {
            containerCss: "col-md-12 mb-3",
        },
    },
    {
        id: "contactNumber",
        lable: "Contact Number",
        Field_Name: "Contact Number",
        fieldType: FormFieldTypes.NUMERIC,
        dataField: "contactNumber",
        fieldSetting: {
            placeholder: "",
        },
        validation: [{ type: "require" }],
        style: {
            containerCss: "col-md-12 mb-2",
        },
    },
    ]
}